import React from 'react'
import { useHistory } from 'react-router'

import { bemJoin } from 'bem-join'

import { FormattedError } from '@app/common/Components/FormattedError'
import {
  AlertType,
  useNotifications
} from '@app/common/services/Notifications/NotificationsProvider'
import { useIntl } from '@app/intl/Intl'
import { Button } from '@app/lib/inputs/Button/Button'
import { Text } from '@app/lib/typography/Text/Text'
import { getAppointmentsPath } from '@app/modules/Appointments'
import { useSendMissedAppointmentEmailMutation } from '@app/queries/SendMissedAppointmentEmail/SendMissedAppointmentEmail.queries'

import './MissedPhoneAppointmentForm.scss'

export type Props = {
  onClose: () => void
  messageId: number
}

export const MissedPhoneAppointmentForm = ({ onClose, messageId }: Props) => {
  const b = bemJoin('missed-phone-appointment-form')
  const { formatMessage } = useIntl()
  const { pushNotification } = useNotifications()
  const history = useHistory()

  const [missedAppointment, { loading }] = useSendMissedAppointmentEmailMutation({
    onError: (error) => {
      pushNotification({
        type: AlertType.error,
        message: <FormattedError error={error} />
      })
    },
    onCompleted: () => {
      history.push(getAppointmentsPath())
    }
  })

  const onSubmit = async () => {
    await missedAppointment({
      variables: { input: { messageId } }
    })
  }

  return (
    <div>
      <Text justification={'center'}>
        {formatMessage({ id: 'MissedPhoneAppointment.Form.Content' })}
      </Text>
      <div className={b('button-group')}>
        <Button color={'danger'} variant={'solid'} size={'sm'} onClick={onClose}>
          {formatMessage({ id: 'MissedPhoneAppointment.Form.CancelButton' })}
        </Button>
        <Button
          color={'primary'}
          variant={'solid'}
          size={'sm'}
          onClick={onSubmit}
          loading={loading}
        >
          {formatMessage({ id: 'MissedPhoneAppointment.Form.ConfirmButton' })}
        </Button>
      </div>
    </div>
  )
}
